import { http } from '../../axios';
import { localContentPrefix } from '../../../config';

const url = `${localContentPrefix}/v1/localcontent/credit`;

export function purchaseCredits(message: string) {
    return http.post(url, { message }, {}).then(response => response.data);
}
